import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 別表対象資産 */
enum AppendixTargetAsset {
  unspecified = '00',
  sixteenOne = '10',
  sixteenTwo = '20',
  sixteenSixUpper = '61',
  sixteenSixLower = '62',
}

const nameConfig = {
  unspecified: new Map([
    [Locale.ja, '指定なし'],
    [Locale.en, 'Unspecified'],
  ]),
  sixteenOne: new Map([
    [Locale.ja, '別表十六(一)対象資産'],
    [Locale.en, 'Appendix Sixteen One Target Asset'],
  ]),
  sixteenTwo: new Map([
    [Locale.ja, '別表十六(二)対象資産'],
    [Locale.en, 'Appendix Sixteen Two Target Asset'],
  ]),
  sixteenSixUpper: new Map([
    [Locale.ja, '別表十六(六)・上段対象資産'],
    [Locale.en, 'Appendix Sixteen Upper Target Asset'],
  ]),
  sixteenSixLower: new Map([
    [Locale.ja, '別表十六(六)・下段対象資産'],
    [Locale.en, 'Appendix Sixteen Lower Target Asset'],
  ]),
};

const toEnum = rawValueToEnum(AppendixTargetAsset, '');
const toDisplay = enumToName(AppendixTargetAsset, nameConfig);
const toDisplayWithPrefix = enumToName(AppendixTargetAsset, nameConfig, { prefix: true });

export const appendixTargetAsset = {
  enum: AppendixTargetAsset,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AppendixTargetAsset };
